import { patchState, signalStore, withComputed, withMethods, withProps, withState } from "@ngrx/signals";
import { s25Resource } from "../../../util/s25.resource";
import { inject } from "@angular/core";
import { CardConfig, CardService } from "../../../services/card.service";
import { S25Util } from "../../../util/s25-util";

type State = {};

export const IdCardsStore = signalStore(
    withState<State>({}),
    withProps((store) => ({
        service: inject(CardService),
        s25util: S25Util,
    })),
    withProps((store) => ({
        configsResource: s25Resource({
            defaultValue: [],
            loader: async ({ params, abortSignal }) => {
                return store.service.getConfigs();
            },
        }),
        regexesResource: s25Resource({
            defaultValue: [],
            loader: async ({ params, abortSignal }) => {
                return store.service.getCardRegexes();
            },
        }),
    })),
    withComputed((store) => ({
        configs: () => store.configsResource.value() ?? [],
        regexes: () => store.regexesResource.value() ?? [],
        hasConfigs: () => !!store.regexesResource.value()?.length,
    })),
    withMethods((store) => ({
        addConfig: async (card: CardConfig) => {
            const [newId, err] = await store.s25util.Maybe(store.service.putConfig(card));
            if (!!err) store.s25util.showError(err);
            else store.configsResource.resource.reload();
            return !err;
        },
        deleteConfig: async (id: number) => {
            await store.service.deleteConfig(id);
            store.configsResource.resource.reload();
        },
        isNameTaken: (name: string, id?: number) => {
            return store.configsResource.value()?.some((config) => config.name === name && config.id !== id);
        },
    })),
);
